import CustomModal from '@/components/ui/customModal';
import convertToReadable from '@/helpers/convertToReadable';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import { Button, Modal, Slider } from 'rsuite';
import styles from './styles.module.scss';

type Props = {
  open: any;
  close: () => void;
  userBonus: string | undefined | number;
  orderId: string | undefined;
  onApplyBonus: (amount: number) => Promise<any>;
  onCancelBonus: () => Promise<any>;
  applyLoading: boolean;
  cancelLoading: boolean;
  initialAppliedAmount: number;
};

export default function BonusModal({
  open,
  close,
  userBonus,
  orderId,
  onApplyBonus,
  onCancelBonus,
  applyLoading,
  cancelLoading,
  initialAppliedAmount,
}: Props) {
  const [code, setCode] = useState<number>(initialAppliedAmount || 0);

  useEffect(() => {
    if (open) {
      setCode(initialAppliedAmount || 0);
    }
  }, [open, initialAppliedAmount]);

  const isLoading = applyLoading || cancelLoading;

  const handleApply = () => {
    if (code <= 0 && initialAppliedAmount <= 0) {
      console.warn('Выберите количество бонусов для списания.');
      return;
    }
    if (code === 0 && initialAppliedAmount > 0) {
      onCancelBonus();
    } else {
      onApplyBonus(code);
    }
  };

  const handleCancel = () => {
    onCancelBonus();
  };
  const t = useTranslations('Drawer.bonus-modal');

  return (
    <div className={styles.root}>
      <CustomModal
        closeOnOutsideClick
        open={open}
        close={close}
        className={styles.modalBonus}
      >
        <div className={styles.header}>
          <Modal.Title className={styles.headerTitle}>{t('title')}</Modal.Title>
          <IoCloseOutline onClick={close} className={styles.headerClose} />
        </div>
        <Modal.Body>
          <div className={styles.inputBox}>
            <input
              type="text"
              disabled
              value={code}
              className={styles.input}
              onChange={(e: any) => setCode(e.target.value)}
            />
            <span className={styles.inputText2}>{t('price')}</span>
          </div>

          <div className={styles.range}>
            <Slider
              progress
              style={{ marginTop: 16 }}
              value={code}
              max={Number(userBonus)}
              className={`${styles.rangeInput} custom-slider`}
              onChange={value => {
                setCode(value);
              }}
            />
          </div>

          <div className={styles.priceRange}>
            <span>0</span>
            <span>{convertToReadable(userBonus)}</span>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.footer}>
          <p className={styles.footerText}>{t('subtext')}</p>
          <Button
            onClick={handleApply}
            className={styles.footerButton1}
            disabled={isLoading || !orderId}
            loading={applyLoading}
          >
            {t('apply')}
          </Button>
          <Button
            onClick={handleCancel}
            className={styles.footerButton2}
            disabled={isLoading || !orderId}
            loading={cancelLoading}
          >
            {t('cancel')}
          </Button>
        </Modal.Footer>
      </CustomModal>
    </div>
  );
}
